import React, { useEffect, useState } from 'react';
import { Banner, BlockStack, Button, Card, Page, Select, Text } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';
import usePosApi from '../hooks/Api';

const ConfigurePrinter = () => {
    const navigate = useNavigate();
    const { request } = usePosApi();
    const [printers, setPrinters] = useState([]);
    const [selectedPrinter, setSelectedPrinter] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);

    const getPrinters = async () => {
        const response = await request(`printnode/printers`);
        if (response.ok) {
            setPrinters(response.data.printers);
            setSelectedPrinter(response.data.default_printer);
        } else {
            setErrorMessage(`Something went wrong: ${response.data?.message} ${response.response.status}`);
        }
    };

    const handlePrinterChange = (value) => setSelectedPrinter(value);

    const savePrinter = async () => {
        shopify.loading(true);
        const response = await request.post(`printnode/printers/default`, {
            printer_id: selectedPrinter,
        });
        shopify.loading(false);
        if (response.ok) {
            shopify.toast.show('Successfully set default printer');
        } else {
            setErrorMessage(`Something went wrong: ${response.data?.message} ${response.response.status}`);
        }
    };

    useEffect(() => {
        shopify.loading(true);
        getPrinters().then(() => {
            shopify.loading(false);
        });
    }, []);

    return (
        <Page
            narrowWidth
            title="Configure Default Printer"
            backAction={{ content: 'Index', onAction: () => navigate(-1) }}
        >
            {errorMessage == null ? (
                <Card roundedAbove="sm">
                    <BlockStack gap={'300'}>
                        <Select
                            label="Choose default printer"
                            options={[
                                { label: 'Select', value: '' },
                                ...printers.map((printer) => {
                                    return {
                                        label: printer.name,
                                        value: `${printer.id}`,
                                    };
                                }),
                            ]}
                            onChange={handlePrinterChange}
                            value={selectedPrinter}
                        />

                        <Button variant="primary" onClick={savePrinter}>
                            Save printer
                        </Button>
                    </BlockStack>
                </Card>
            ) : (
                <Banner
                    tone="critical"
                    title="Error"
                    onDismiss={() => {
                        setErrorMessage(null);
                    }}
                >
                    <Text tone="critical">{errorMessage}</Text>
                </Banner>
            )}
        </Page>
    );
};

export default ConfigurePrinter;
